export enum SliderButtonSize {
  Large = 'h-[44px] w-[44px] before:h-[16px] before:w-[16px] top-[calc(50%_-_22px)]',
  Small = 'h-[28px] w-[28px] before:h-[10px] before:w-[10px] top-[calc(50%_-_14px)]',
}

export enum NumberOfPreloadedImages {
  ForUnlikelyUse = 1,
  ForMediumLikelyUse = 2,
  ForLikelyUse = 5,
}

export enum SliderButtonSide {
  Left = 'left-[28px] before:icon-slider_arrow_left_dark',
  Right = 'right-[28px] before:icon-slider_arrow_right_dark',
}

export const ICON_POSITION = {
  [SliderButtonSize.Small + SliderButtonSide.Left]: 'before:left-[8px] before:top-[9px]',
  [SliderButtonSize.Small + SliderButtonSide.Right]: 'before:left-[10px] before:top-[9px]',
  [SliderButtonSize.Large + SliderButtonSide.Left]: 'before:left-[12.5px] before:top-[15px]',
  [SliderButtonSize.Large + SliderButtonSide.Right]: 'before:left-[14px] before:top-[15px]',
}
